import React from 'react'
import EpisodeOne from './step2/episode' 
import { StepContextProvider } from '../../../../components/StepContext';
const Step2 = (props) => {  
    return (
        <div className="panel-body">
            <div className="container"> 
            <EpisodeOne handleWizard={props} handleProgress={props.handleProgress}/>
            </div>
        </div>)
}
export default StepContextProvider(Step2, {
    viewHider(props) {
        if (props.innerTexts.noYerindelikUygunlukStep) {
            return true
        }
    }
})
